import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allMasterDataList: [],
    dropDownList:{},
    addModal: false
};

// fetch all remanufacturing reasons
export const fetchMasterData = createAsyncThunk(
    'bmr/fetchMasterData',
    async (params, { rejectWithValue }) => {
        try {
            if(params?.slug){
            const response = await api.post(`/master/${params?.slug}/reason`,params);
            return response.data;
            }
            return
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add remanufacturing reason
export const addMasterData = createAsyncThunk(
    'bmr/addMasterData',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const {data, slug} = args
            const response = await api.post('/master/create', data);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchMasterData({ page: 1, per_page: 10, slug:slug }));
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit remanufacturing reason
export const editMasterData = createAsyncThunk(
    'bmr/editMasterUpdateData',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data,slug, editId } = args;
            const response = await api.put(`/master/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchMasterData({ page: 1, per_page: 10, slug:slug }));
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// delete remanufacturing reason
export const deleteMasterData = createAsyncThunk(
    'bmr/masterDelete',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id, slug } = args;
            const response = await api.delete(`/master/delete/${id}?type=${slug}`);
            notify.success(response.data.message);
            dispatch(fetchMasterData({ page: 1, per_page: 10, slug:slug }));
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info get Esential patient for the portal 1
export const fetchManufecturingButtonDropDown = createAsyncThunk(
    'bmr/terminate/dropdown',
    async (type, { rejectWithValue }) => {
        try {
            const response = await api.get(`/master/${type}/dropdown`);
              return { type, data: response?.data };
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);



const bmrCutomMasterSlice = createSlice({
    name: 'bmrCutomMaster',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true;
        },
        disableAddModal(state) {
            state.addModal = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // fetch
            .addCase(fetchMasterData.pending, (state) => {
                state.isLoading = true;
            })
             .addCase(fetchMasterData.fulfilled, (state, action) => {
                    // Structure the data to match what the component expects
                    state.allMasterDataList = {
                      items: action.payload?.data ?? [],
                      pageDetails: action.payload?.page_details ?? {
                        no_of_records: 0,
                        page: 1,
                        per_page: 10
                      }
                    };
                    state.isLoading = false;
                  })
            .addCase(fetchMasterData.rejected, (state) => {
                state.isLoading = false;
            })
            // add
            .addCase(addMasterData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addMasterData.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addMasterData.rejected, (state) => {
                state.isLoading = false;
            })
            // edit
            .addCase(editMasterData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editMasterData.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editMasterData.rejected, (state) => {
                state.isLoading = false;
            })
            // delete
            .addCase(deleteMasterData.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteMasterData.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteMasterData.rejected, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchManufecturingButtonDropDown.pending, (state) => {
                state.isLoading = true;
            })
           .addCase(fetchManufecturingButtonDropDown.fulfilled, (state, action) => {
            state.isLoading = false;
            const { type, data } = action.payload;
            
            // Ensure dropDownList exists - create a new object if it doesn't
            if (!state.dropDownList) {
                state.dropDownList = {};
            }
            
            // Create transformed items array safely
            const items = (data?.data?.items || []).map((it) => ({
                label: it?.name || '',
                name: it?.name || '',
                id: it?.id || '',
                value: it?.id || ''
            }));
            
            // Create a new object to maintain immutability
            state.dropDownList = {
                ...state.dropDownList, // Keep existing properties
                [type]: items // Replace or add the new type array
            };
        })
            .addCase(fetchManufecturingButtonDropDown.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const { disableAddModal, enableAddModal } = bmrCutomMasterSlice.actions;
export const selectDropDownDataMaster = (type ='') => (state) =>
  state.bmrCutomMaster.dropDownList?.[type] || [];
export const selectMasterDataLoading = (state) => state.bmrCutomMaster.isLoading;
export const selectMasterAllData = (state) => state.bmrCutomMaster.allMasterDataList;
export const selectBmrAddMasterModal = (state) => state.bmrCutomMaster.addModal;

export default bmrCutomMasterSlice.reducer;
